export class WarehouseHandlingDetailModal {
  public constructor() {
    this.warehouseHandlingCount = 0;
    this.adjustment = 0;
    this.finalCount = 0;

    this.packageCount = 0;

    this.inventoryItem = [];
  }

  public inventoryItem: WarehouseHandlingDetailItem[];
  public selectItem?: WarehouseHandlingDetailItem;

  public barcode?: string;

  public alertMessage?: string;

  public description?: string;

  public adjustment: number;
  public finalCount: number;
  public packageCount: number;
  public warehouseHandlingCount: number;

  public adjustmentIsDecrease?: boolean;

  // public calculateAdjustment() {
  //   if (this.selectItem == null) {
  //     this.adjustmentIsDecrease = undefined;
  //     this.adjustment = 0;
  //     return;
  //   }

  //   const different =
  //     this.warehouseHandlingCount -
  //     this.selectItem.count +
  //     this.selectItem.warehouseHandlingCount;

  //   if (different < 0) {
  //     this.adjustment = different * -1;
  //     this.adjustmentIsDecrease = true;
  //   } else {
  //     this.adjustment = different;
  //     if (different == 0) {
  //       this.adjustmentIsDecrease = undefined;
  //     } else {
  //       this.adjustmentIsDecrease = false;
  //     }
  //   }
  // }
}
export class ImportWarehouseHandlingDetailModal {
  public constructor(backendJson: any) {
    this.countingDrugPackage = 0;
    this.countingWarehouseHandlingCount = 0;
    if (backendJson != null) {
      this.id=backendJson.id;
      this.drugId = backendJson.drugId;
      this.drugName = backendJson.drugName;
      this.drugPersianName = backendJson.drugPersianName;
      this.expireDate = backendJson.expireDate;
      this.count = backendJson.count;
      this.warehouseHandlingCount = backendJson.warehouseHandlingCount;
      this.drugPackageCount = backendJson.drugPackageCount;
      this.sellPrice = backendJson.sellPrice;
      this.inventoryDetailId = backendJson.inventoryDetailId;
      this.inventoryId = backendJson.inventoryId;

      this.adjustment = backendJson.count - backendJson.warehouseHandlingCount;
      this.countingFinalCount = backendJson.warehouseHandlingCount;
      this.adjustment = backendJson.count - backendJson.warehouseHandlingCount;
    } else {
      this.id='';
      this.drugId = '';
      this.drugName = '';
      this.drugPersianName = '';
      this.adjustment = 0;
      this.countingFinalCount = 0;
      this.expireDate = '';
      this.count = 0;
      this.warehouseHandlingCount = 0;
      this.drugPackageCount = 1;
      this.sellPrice = 0;
      this.inventoryDetailId = '';
      this.inventoryId = '';

      this.adjustment = 0;
    }
    this.countingAdjustment = this.adjustment;
  }
  public id: string;
  public drugId: string;
  public drugName: string;
  public drugPersianName: string;
  public expireDate: string;
  public count: number;
  public warehouseHandlingCount: number;
  public drugPackageCount: number;
  public sellPrice: number;
  public inventoryDetailId: string;
  public inventoryId: string;
  public companyName: string='';

  public alertMessage?: string;
  public description!: string;

  public adjustment: number;

  public countingDrugPackage: number;
  public countingWarehouseHandlingCount: number;
  public countingAdjustment: number;
  public countingFinalCount: number;

}

export class WarehouseHandlingDetailItem {
  public constructor() {
    this.count = 0;
    this.sellPrice = 0;
    this.adjustment = 0;
    this.buyPrice = 0;
    this.drugPackageCount = 0;
    this.warehouseHandlingCount = 0;
  }

  public id?: string;

  public drugName?: string;
  public drugPersianName?: string;
  public expireDate?: string;
  public lot?: string;
  public drugPackageCount: number;
  public sellPrice: number;
  public buyPrice: number;
  public count: number;
  public drugId?: string;
  public inventoryId?: string;
  public inventoryDetailId?: string;
  public warehouseHandlingCount: number;
  public adjustment: number;
}
